import Error from '../model/Error';
import axios from 'axios';

export default class ClubSalesListInvoicingRepository {

    static getInvoicingStatus(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/sales-list/invoicing`)
                .then(response => resolve(response.data.data.isInvoicingRunning))
                .catch(error => reject(Error.fromResponse(error.response)))
        });
    }

}
